import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// src/index.js
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom'
import { initGA } from './analytics';
import { LocaleProvider } from './i18n';

// Google Analytics 4 の初期化
initGA();


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter> {/*BrowserRouterで囲む*/}
    <LocaleProvider>
      <App />
    </LocaleProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
